// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__toast--oqb1C {\r\n    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);\r\n    border-radius: 3px;\r\n}\r\n.styles-module__body--2EXC9 {\r\n    color: rgba(0, 0, 0, .87);\r\n}\r\n.styles-module__progress--zd24c {\r\n    background: linear-gradient(90deg, var(--ls-color-1), var(--ls-color-3))\r\n}\r\n\r\n.Toastify__toast--info .styles-module__body--2EXC9 {\r\n    color: #ffffff;\r\n}\r\n.Toastify__toast--success .styles-module__body--2EXC9 {\r\n    color: #ffffff;\r\n}\r\n.Toastify__toast--warning .styles-module__body--2EXC9 {\r\n    color: #ffffff;\r\n}\r\n.Toastify__toast--error .styles-module__body--2EXC9 {\r\n    color: #ffffff;\r\n}\r\n\r\n\r\n", ""]);
// Exports
exports.locals = {
	"toast": "styles-module__toast--oqb1C",
	"body": "styles-module__body--2EXC9",
	"progress": "styles-module__progress--zd24c"
};
module.exports = exports;
